module.exports = __webpack_public_path__ + "img/a-3.053bcf8b.png";